import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormGroup from './form-group';
import FormItem from './form-item';

class FormField extends Component {

  render() {
    const {
      children,
      formGroupProps,
      formItemProps,
      id,
      input,
      label,
      labelProps,
      ...otherProps
    } = this.props;

    const formGroupAttributes = {
      ...formGroupProps,
      ...fp.pick(fp.keys(FormGroup.propTypes), otherProps),
      id
    };

    const formItemAttributes = {
      ...formItemProps,
      ...fp.pick(fp.keys(FormItem.propTypes), otherProps)
    };

    // Explicit undefined check, so that null can be passed and no label rendered
    const labelText = label !== undefined ?
      typeof (label) === 'function' ?
        label(fp.startCase(id)) :
        label :
      fp.startCase(id);

    const labelAttributes = {
      ...labelProps,
      htmlFor: id
    }

    const validationText = otherProps.validation ? ` (${otherProps.validation})` : ''

    return (
      <FormGroup {...formGroupAttributes}>
        <FormItem {...formItemAttributes}>
          {input}
          {
            labelText ?
              <label {...labelAttributes}>
                <div className='no-wrap'>
                  {labelText}{validationText}
                </div>
              </label> :
              null
          }
          {children}
        </FormItem>
      </FormGroup>
    );
  }
}

FormField.propTypes = {
  ...FormGroup.propTypes,
  ...FormItem.propTypes,
  formGroupProps: PropTypes.object,
  formItemProps: PropTypes.object,
  id: PropTypes.string,
  input: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  labelProps: PropTypes.object
};

export default FormField;



// WEBPACK FOOTER //
// ./src/containers/components/form-field.js